/**
 * /votre-seance/a-propos — Volontairement allégé pour l'instant, à retravailler
 * plus tard sur le parcours et les formations comme demandé.
 */
import React from "react";
import { Link } from "react-router-dom";
import { Seo } from "../../components/Layout";
import { PageHero, ProseSection, EndCTA } from "../../components/PageParts";
import { Portrait, hasPortrait } from "../../components/PortraitSlot";

export default function APropos() {
  const BC = [{ to: "/", label: "Accueil" }, { to: "/votre-seance", label: "Votre séance" }, { label: "À propos" }];
  return (
    <>
      <Seo
        title="À propos de Valentine DL"
        description="Valentine DL, praticienne en hypnose régressive et spirituelle à Pantin (15 min de Paris) et en ligne. Une approche sobre, humaine et centrée sur le discernement."
        canonical="https://www.parfaitsimparfaits.fr/votre-seance/a-propos"
      />
      <PageHero breadcrumb={BC} eyebrow="Qui je suis" title="Valentine DL," italic="praticienne en hypnose" />

      <section className="pb-16 px-6 lg:px-10">
        <div className={`mx-auto ${hasPortrait() ? "max-w-5xl grid grid-cols-1 md:grid-cols-12 gap-10 items-start" : "max-w-3xl"}`}>
          {hasPortrait() && (
            <div className="md:col-span-4">
              <Portrait alt="Valentine DL — praticienne en hypnose à Pantin" />
            </div>
          )}
          <div className={`${hasPortrait() ? "md:col-span-8" : ""} prose-mystic text-lg text-sand-700 leading-relaxed space-y-5`}>
            <p>
              Je suis <strong className="text-sand-900 font-medium">Valentine DL</strong>,
              praticienne en <strong className="text-sand-900 font-medium">hypnose régressive et spirituelle</strong>.
              J'exerce à <strong className="text-sand-900 font-medium">Pantin (93)</strong>,
              à proximité du métro Église de Pantin — à 15 minutes de Paris — ainsi qu'
              <strong className="text-sand-900 font-medium">en ligne</strong>, en visioconférence.
            </p>
            <p>
              Je poursuis actuellement mon parcours de formation en{" "}
              <strong className="text-sand-900 font-medium">hypnose ericksonienne</strong>{" "}
              ; les séances seront proposées à partir de <em>septembre 2026</em>.
            </p>
            <p>
              Mon approche se veut <strong className="text-sand-900 font-medium">sobre, contemporaine et
              humaine</strong>. Je crois profondément qu'un accompagnement de qualité ne repose ni sur
              le sensationnel ni sur les promesses, mais sur une <strong className="text-sand-900 font-medium">présence
              juste</strong> et sur le respect du rythme de chacun·e.
            </p>
            <p>
              Mon rôle&nbsp;: tenir un cadre sûr, poser les bonnes questions, guider avec précision —
              vous aider à accéder à vos propres ressources intérieures. Vous pouvez en découvrir davantage
              sur le{" "}
              <Link to="/votre-seance/deroulement" className="text-[#B07A45] underline hover:text-sand-900">
                déroulement d'une séance
              </Link>
              .
            </p>
          </div>
        </div>
      </section>

      <EndCTA testid="apropos-end" title="Envie de faire connaissance ?" text="Le plus simple est de m'écrire quelques mots par e-mail." />
    </>
  );
}
